module.exports = __webpack_public_path__ + "assets/img/favicon/favicon-16x16.209999da043ef7bd49f71c05b7d4a07a.png";